export default {
  createNote: 'clickedButton_createNote',
  createSeedling: 'clickedButton_createSeedling',
  upgradeToFull: 'clickedButton_upgradeToFull',
  visitSeedlingPage: 'clickedButton_visitSeedlingPage',
  whatIsNDVI: 'clickedButton_whatIsNDVI',
  contractNDVI: 'clickedButton_contractNDVI',
  seeAllFields: 'clickedButton_seeAllFields',
}
